export const USD = 'USD';
export const BITCOIN = 'BTC';
export const ETH = 'ETH';
export const SOV = 'SOV';
export const BTC_RENDER_PRECISION = 8;
export const TOKEN_RENDER_PRECISION = 4;
